<template>
    <div style=" background: rgb(240, 248, 252);padding-bottom: 30px">
        <div style="padding: 10px 20px; display: flex; flex-direction: column; flex: 1; justify-content: center; align-items: center;"
            v-if="cliente.CLASSCLICODIGO > 2">
            <h3>
                <b style="color: red;font-weight: 900;">Cliente Bloqueado </b>
            </h3>
            <h4 v-if="cliente.DATAEXTRORDINARIA">
                <b>Autorizado extraordinariamente até {{ cliente.DATAEXTRORDINARIA
                    | formatDateNormalSH }}</b>
            </h4>
            <div v-if="cliente.CLASSCLICODIGO > 2 && !cliente.DATAEXTRORDINARIA"
                style="display: flex; flex: 1; justify-content: center;">
                <md-button @click="autorizacaoExtraordinaria(cliente)" class="md-primary">
                    Autorização Extraordinária (+3 dias)
                </md-button>
            </div>
            <md-snackbar :md-active.sync="msg">{{ msg }}</md-snackbar>
        </div>

        <div style="padding: 25px; display: flex;justify-content: space-between;">
            <div style="margin:20px;">
                <div class="subtitle-2">
                    <b>Codigo:</b>
                    {{ cliente.CLICODIGO || 'Não Possui' }}
                </div>
                <div class="subtitle-2">
                    <b>Nome:</b>
                    {{ cliente.CLINOME || 'Não Possui' }}
                </div>
                <div class="subtitle-2">
                    <b>Nome Usual:</b>
                    {{ cliente.CLINOMEUSUAL || 'Não Possui' }}
                </div>
                <div class="subtitle-2">
                    <b>CNPJ:</b>
                    {{ cliente.CLICNPJ || 'Não Possui' }}
                </div>
                <div class="subtitle-2">
                    <b>E-mail:</b>
                    {{ cliente.CLIEMAIL || 'Não Possui' }}
                </div>
                <div class="subtitle-2">
                    <b>Bugliza ID:</b>
                    {{ cliente.BUGZILLAID || 'Não Possui' }}
                </div>
                <div class="subtitle-2">
                    <b>IE:</b>
                    {{ cliente.CLIIE || 'Não Possui' }}
                </div>
                <div class="subtitle-2">
                    <b>Proprietário:</b>
                    {{ cliente.CLIPROPRIETARIO || 'Não Possui' }}
                </div>
                <div class="subtitle-2">
                    <b>Cliente Ativo:</b>
                    {{ cliente.CLIATIVO == 'S' ? 'Sim' : 'Não' || 'Não Possui' }}
                </div>
            </div>
            <div style="margin: 20px;">
                <div class="subtitle-2">
                    <b>Telefone:</b>
                    {{ cliente.CLITELEFONEPRINCIPAL || 'Não Possui' }}
                </div>
                <div class="subtitle-2">
                    <b>Outro Telefone:</b>
                    {{ cliente.CLIOUTROTELEFONE || 'Não Possui' }}
                </div>
                <div class="subtitle-2">
                    <b>Usuario Chave:</b>
                    {{ cliente.CLIUSUARIOCHAVE || 'Não Possui' }}
                </div>
                <div class="subtitle-2">
                    <b>Endereço:</b>
                    {{ cliente.ENDCOMLPETE || 'Não Possui' }}
                </div>
                <div class="subtitle-2">
                    <b>Latitude:</b>
                    {{ cliente.LATITUDE ? cliente.LATITUDE.toFixed(5) : 'Não Possui' }}
                </div>
                <div class="subtitle-2">
                    <b>Longitude:</b>
                    {{ cliente.LONGITUDE ? cliente.LONGITUDE.toFixed(5) : 'Não Possui' }}
                </div>
                <div class="subtitle-2">
                    <b>Versão EMS:</b>
                    <span style="color: red; font-weight: 500;">{{ cliente.CLIEMSVERSAO }}</span>
                </div>
            </div>
            <div style="margin: 20px;">
                <!-- <div class="subtitle-2">
                      <b>Data atualização EMS:</b>
                      {{cliente.CLISISDATAHORA | formatDateNormalSH}}
                    </div>
                    <div class="subtitle-2">
                      <b>Sis Código:</b>
                      {{cliente.SISCODIGO || 'Não Possui'}}
                    </div>
                    <div class="subtitle-2">
                      <b>Versão Firebird:</b>
                      {{cliente.VERSAOFIREBIRD || 'Não Possui'}}
                    </div>
                    <div class="subtitle-2">
                      <b>Ultimo Log:</b>
                      <span
                        :style="{ 'background-color': calcDiffDates(cliente.MAXLOGDATAHORA) }"
                      >{{cliente.MAXLOGDATAHORA | formatDateNormal}}</span>
        </div>-->
                <div class="subtitle-2">
                    <b>Destino dos Chamados de Suporte:</b>

                    <select id="selectbox" @change="destinoChamados(cliente.CLICODIGO, cliente.CLIDESTSUPORTE)"
                        v-model="cliente.CLIDESTSUPORTE">
                        <option selected disabled hidden value="null">Selecione</option>
                        <option class="optionsle" value="1">Suporte</option>
                        <option class="optionsle" value="2">Implantação</option>
                        <option class="optionsle" value="3">Monitoramento</option>
                    </select>
                </div>
                <div class="subtitle-2">
                    <b>Aplicativo de Atendimento Online:</b>

                    <select id="selectbox" @change="aplicativoChamados(cliente.CLICODIGO, cliente.CLIAPPSUPORTE)"
                        v-model="cliente.CLIAPPSUPORTE">
                        <option selected disabled hidden value="null">Selecione</option>
                        <option class="optionsle" value="1">LiveZilla</option>
                        <option class="optionsle" value="2">Jira</option>
                    </select>
                </div>
                <div class="subtitle-2">
                    <b>E-mail Jira:</b>
                    {{ cliente.CLIJIEMAIL ? cliente.CLIJIEMAIL : '' }}
                </div>
                <div class="subtitle-2">
                    <b>Código Jira:</b>
                    {{ cliente.CLIJIORGANIZATIONID ? cliente.CLIJIORGANIZATIONID : '' }}
                </div>
                <div>
                    <InputBox @success="() => {
                            //applyAppChamados(cliente.CLICODIGO, cliente.CLIAPPSUPORTE);

                            showInputEmail = false;
                            msg = 'Sucesso!';
                            /*selected.forEach(el =>{
                              if(el.BLOQUEADO) selected.remove(el)
                            });*/
                            //detalhesClientes(cliente)
                        }" @cancel="(e) => {
            showInputEmail = false;
            cliente.CLIAPPSUPORTE = '1';
            e ? (msg = e) : (msg = 'Não foi possível alterar o cliente.')
        }" :cliente="cliente" :open="showInputEmail" />
                </div>
                <div class="subtitle-2">
                    <b>Bloqueio de liberação de arquivos</b>
                    <v-sheet style="margin-right: 25px;background: transparent">
                        <v-switch v-model="cliente.BLOQUEADO" inset color="#2A5377"
                            @change="bloqueiaLiberacao(cliente, $event)"></v-switch>
                    </v-sheet>
                    <div class="bloqueiobox" v-if="cliente.BLOQUEADO && cliente.USUARIOBLOQUEIO">
                        Ultimo bloqueio feito em
                        <span style="color:red">{{ cliente.DATABLOQUEIO | formatDateNormal }}</span>, pelo usuário:
                        <span style="color:red">{{ cliente.USUARIOBLOQUEIO }}</span>. Motivo:
                        <span style="color:red">{{ cliente.MOTIVO }}</span>
                    </div>
                    <LoginDialog @success="() => {
                            LoginDialogTrigger = false;
                            msg = 'Sucesso!';
                            selected.forEach(el => {
                                if (el.BLOQUEADO) selected.remove(el)
                            });
                            detalhesClientes(cliente)
                        }" @cancel="(e) => {
            LoginDialogTrigger = false;
            cliente.BLOQUEADO = !cliente.BLOQUEADO;
            e ? (msg = e) : (msg = 'Não foi possível alterar o cliente.')
        }" :cliente="cliente" :open="LoginDialogTrigger" />
                </div>
            </div>
            <!--<div class="mapcontent">
                <GmapMap ref="mapRef" :options="mapOptions" :center="{ lat: cliente.LATITUDE, lng: cliente.LONGITUDE }"
                    :zoom="13" map-type-id="satellite" style=" height: 250px!important;">
                    <GmapMarker ref="myMarker" @click="center = { lat: cliente.LATITUDE, lng: cliente.LONGITUDE }"
                        :position="google && new google.maps.LatLng(cliente.LATITUDE, cliente.LONGITUDE)"
                        :icon="recIcon" />
                </GmapMap>
                <md-button @click="defaultLocation(cliente)" class="md-primary">
                    <md-icon>location_on</md-icon>Confirmar Local
                </md-button>
            </div>-->
        </div>
        <div class="containertable">
            <detalhesLicensa style="width:100%;" :cliente="cliente" />
        </div>
        <div class="containertable">
            <div class="text-center">
                <h4><b>Atualizações</b></h4>
            </div>
            <table v-if="Array.isArray(cliente.CLIENTEVERSOESATUAL)">
                <tr>
                    <th>Sistemas</th>
                    <th>Versões</th>
                    <th>Logs</th>
                    <th>Versão Firebird</th>
                </tr>
                <tr v-for="(versao, i ) in cliente.CLIENTEVERSOESATUAL" :key="i">

                    <td>{{ cliente.SISCODIGOS[i] }}</td>
                    <td>{{ cliente.CLIENTEVERSOESATUAL[i] }}</td>
                    <td>{{ cliente.CLISISDATAHORAS[i] | formatDateNormal }}</td>
                    <td>{{ cliente.VERSAOFIREBIRDS[i] }}</td>
                </tr>
            </table>

            <table v-else-if="cliente.CLIENTEVERSOESATUAL">
                <tr>
                    <th>Sistema</th>
                    <th>Versão</th>
                    <th>Log</th>
                    <th>Versão Firebird</th>
                </tr>
                <tr>
                    <td>{{ cliente.SISCODIGOS }}</td>
                    <td>{{ cliente.CLIENTEVERSOESATUAL }}</td>
                    <td>{{ cliente.CLISISDATAHORAS | formatDateNormal }}</td>
                    <td>{{ cliente.VERSAOFIREBIRDS }}</td>
                </tr>
            </table>
            <arquivosliberados style="width:100%;" :cliente="cliente" />
        </div>
        <div class="containertable">
            <dependentes style="width:100%;" :cliente="cliente" />
        </div>
        <md-snackbar :md-active.sync="msg">{{ msg }}</md-snackbar>
    </div>
</template>
<script>
import * as ClientesService from "../../providers/clientes.service";
import LoginDialog from "../Common/LoginDialog";
import InputBox from "../Common/InputBox";
import arquivosliberados from "./arquivosliberados";
import detalhesLicensa from "./detalhesLicensa";
import dependentes from "./dependentes";
import store from "@/store/index.js";

export default {
    props: ["cliente"],
    data() {
        return {
            LoginDialogTrigger: false,
            showInputEmail: false,
            msg: false
        }
    },
    components: {
        LoginDialog,
        InputBox,
        arquivosliberados,
        detalhesLicensa,
        dependentes
    },
    created() {
        this.detalhesClientes(this.cliente);
    },
    computed: {
        user() {
            return store.state.user.data
        },
    },    
    methods: {
        bloqueiaLiberacao(cliente, ev) {
            this.LoginDialogTrigger = true;
        },
        detalhesClientes(cliente) {
            var self = this;
            ClientesService.getDetalhesClientes({
                CLICODIGO: self.cliente.CLICODIGO
            }).then(r => {
                this.cliente = r[0];
            });
        },
        destinoChamados(_CLICODIGO, _CLIDESTSUPORTE) {
            var self = this;
            var body = {
                CLICODIGO: _CLICODIGO,
                CLIDESTSUPORTE: _CLIDESTSUPORTE
            };

            ClientesService.changeDestinoChamados(body).then(r => {
                self.msg = r.Message;
            });
        },
        aplicativoChamados(_CLICODIGO, _CLIAPPSUPORTE) {
            if (_CLIAPPSUPORTE == '2')
                this.showInputEmail = true;
            else {
                var self = this;
                var body = {
                    CLICODIGO: _CLICODIGO,
                    CLIAPPSUPORTE: _CLIAPPSUPORTE
                };

                ClientesService.changeAplicativoChamados(body).then(r => {
                    self.msg = r.Message;
                });
            }
        },

        autorizacaoExtraordinaria(cliente) {
            ClientesService.autorizacaoExtraordinaria({ CLICODIGO: cliente.CLICODIGO, USUCODIGO: this.user.USUCODIGO }).then(r => {
                self.msg = 'Sucesso!'
                this.detalhesClientes(cliente)
            })
        }
    }
};
</script>
<style scoped>
.bloqueiobox {
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #999;
}

.controlstop {
    display: flex;
    justify-content: flex-end;
}

#tabelaclientes {
    z-index: 100 !important;
}

.v-datatable__actions__range-controls {
    color: #000;
}

.refreshicon {
    margin: 10px;
}

.subtitle-2 {
    max-width: 270px;
    min-height: 30px;
}

.overlayy {
    z-index: 10;
    background: rgba(0, 0, 0, 0.39);
    position: absolute;
    width: 100%;
    height: 99%;
    top: 0;
    border-radius: 5px;
    left: 0;
}

li {
    min-height: 58px;
}

.iconedit {
    font-size: 15px !important;
    position: absolute;
    top: 5px;
    right: 5px;
    opacity: 0;
    cursor: pointer;
}

.descarrude:hover .iconedit {
    opacity: 1;
}

.iconedit:hover {
    font-size: 16px !important;
    position: absolute;
    color: #000 !important;
    top: 5px;
}

.mapcontent {
    flex-flow: column;
    width: 32%;
    justify-content: center;
    align-items: center;
    display: flex;
}

span,
div,
table,
td,
tr,
th {
    transition: all 0.3s ease !important;
}

#selectbox {
    margin-bottom: 1em;
    padding: 0.25em;
    border: 0;
    border-bottom: 2px solid #333;
    font-weight: bold;
    border-radius: 0;
}

.optionsle {
    background: #333;
    border: 2px solid #333;
    margin: 5px;
    padding: 5px;
    color: #fff;
}

.containertable {
    margin: 0px 45px 45px 45px;
    display: flex;
    background: #fff;
    flex-flow: column;
}

.containertable table {
    width: 100%;
}

.containertable td,
th {
    border: 1px solid transparent !important;
    border-color: transparent !important;
    text-align: left;
    padding: 8px;
}

.containertable tr:nth-child(even) {
    background-color: #CFDFE5;
}

.containertable tr:hover {
    background-color: #FF0000;
}
</style>